import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser'
import { CARD_TYPE } from '../CardListing';

const ClientCard = ({ cardData, cardType }) => {
  const {
    headline,
    imageAlt,
    imageUrl,
    isExternal,
    subHeadline,  // CARD_TYPE.client
    title,        // CARD_TYPE.leader
    location,     // CARD_TYPE.event
    date,         // CARD_TYPE.event
    url
  } = cardData;

  return (
    <a href={url} target={isExternal ? '_blank' : '_self'} className="client-card">
      {imageUrl && (
        <picture className={`client-card__image ${cardType !== CARD_TYPE.client ? 'client-card__image-cover' : ''}`}>
          <img src={imageUrl} alt={imageAlt} loading="lazy"/>
        </picture>
      )}
      <div className="client-card__content">
        <div className="client-card__headline">
          <h4 className="client-card__name">{parse(headline)}</h4>
          <span className={`cta-decorator-v2 cta-decorator-v2--${isExternal ? 'external' : 'internal'} bg-dark`}>
            <svg viewBox={isExternal ? '0 0 19 18' : '0 0 18 18'}>
              <use xlinkHref={isExternal ? '#link-arrow-icon' : '#link-arrow-right-icon'}/>
            </svg>
          </span>
        </div>
        <div className="client-card__description">
          <p>
            {subHeadline && parse(subHeadline)}
            {title && parse(title)}
            {date && parse(date)}
            {date && location && <br/>}
            {location && parse(location)}
          </p>
        </div>
      </div>
    </a>
  );
};

ClientCard.propTypes = {
  cardData: PropTypes.object.isRequired
};

export default ClientCard;
